import { apiRequest } from "../../util/apiUtils";


export const testimonialListData = async (params) => {
  try {
    const res = await apiRequest("get", "front/testimonial/list", {
      queries: params,
    });
    return res?.data;
  } catch (error) {
    return error;
  }
};
